<div>
    <app-header *ngIf="mostrarHeader"></app-header>
    <div class="container mt-5">
        <h2 class="title">Documentos para declaração do IR</h2>

        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="d-flex flex-column mb-5">
            <p class="subtitle mb-5">Olá! Digite seu <strong>CPF</strong> e <strong>data de nascimento</strong> para
                confirmar sua identidade:</p>

            <div class="form-group">
                <label for="cpf">CPF <span *ngIf="form.get('cpf')?.invalid && form.get('cpf')?.touched"
                        class="required">*</span></label>
                <input id="cpf" formControlName="cpf" class="form-control" placeholder="000.000.000-00"
                    mask="000.000.000-00" inputmode="numeric" [dropSpecialCharacters]="true" (blur)="onCpfBlur()">
                <span *ngIf="form.get('cpf')?.invalid && form.get('cpf')?.touched" class="error-message">
                    CPF é obrigatório
                </span>
            </div>

            <div class="form-group">
                <label for="dataNascimento">Data de Nascimento <span
                        *ngIf="form.get('cpf')?.invalid && form.get('cpf')?.touched" class="required">*</span></label>
                <input id="dataNascimento" type="date" placeholder="Digite a sua data de nascimento"
                    formControlName="dataNascimento" class="form-control">
                <span *ngIf="form.get('dataNascimento')?.invalid && form.get('dataNascimento')?.touched"
                    class="error-message">
                    Data de nascimento é obrigatória
                </span>
                <span *ngIf="erroAutenticacao"
                    class="error-message">
                    {{ mensagemErro}}
                </span>
            </div>

            <button type="submit" class="btn btn-primary" [disabled]="!form.valid || isLoading">
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {{ isLoading ? 'Processando...' : 'Continuar' }}
            </button>

        </form>
    </div>

</div>
